import React from 'react';
import PropTypes from 'prop-types';

const BasicInput = (props) => (
  <div className={`form-field ${props.error ? 'has-error' : ''}`}>
    <div className="form-control">
      <input
        {...props}
        className={`form-input ${props.type === 'number' ? 'is-numeric' : ''}`}
      />
    </div>
    {
      props.error && <p className="help-block">{props.error}</p>
    }
  </div>
);

BasicInput.propTypes = {
  type: PropTypes.string,
  error: PropTypes.string
};

export default BasicInput;



// WEBPACK FOOTER //
// ./src/components/ui/BasicInput.js